import React from "react";
import styles from "./metroCard.module.scss";
import { Media } from "../../../../../types/media";
import cx from "classnames";
import Button from "../../../../../components/button";
import _ from "lodash";
import Tooltip from "src/components/tooltip/index";
import { useNavigate } from "react-router-dom";
import { NavigateEntity } from "src/components/NavigateEntity";

const DefaultAssetIcon = "/images/assets/default_asset.jpg";

interface Settings {
  share: boolean;
}
interface ImageItem {
  id: string;
  name: string;
  icon: Media;
  settings?: Settings;

}

interface MetroAssetCardProps {
  items: ImageItem[];
}

const MetroAssetCard: React.FC<MetroAssetCardProps> = ({ items }) => {
  const navigate = useNavigate();
  const largeItem = items && items[0];
  const rightItems = items && items.slice(1, 4);

  return (
    <div className={styles.metroContainer}>
      <div className={styles.itemLarge}>
        <p className={styles.title}>{largeItem?.name}</p>
        <NavigateEntity
          path ={`/assets/${largeItem?.id}`}
          className={styles.link} 
          onClick={() => {
            navigate(`/assets/${largeItem?.id}`)
          }}
        >  
          <Button
            text="explore"
            variant="tertiary"
            icon="paperflite-right-arrow"
          />
        </NavigateEntity>

        <div className={styles.largeItem}>
          <NavigateEntity
            path={`/assets/${largeItem?.id}`}
            className={styles.link}
            onClick={(e) => {
              e.preventDefault()
              navigate(`/assets/${largeItem?.id}`)
            }}
          >  
            <img src={largeItem?.icon?.full || DefaultAssetIcon} />
          </NavigateEntity>
          {largeItem?.settings && !largeItem.settings.share && 
          <div className={styles.indicators}>
            <Tooltip content={'Internal use only'} placement='top'>
              <i className="paperflite-lock"></i>
            </Tooltip>
          </div>
          }
          </div>
        </div>

      <div className={styles.itemsRight}>
        {rightItems?.map((item, index) => (
          <div
            key={index}
            className={cx(styles.item, `${styles[`item${index + 1}`]}`)}
          >
            <div className={styles.rightItem}>
              {item?.settings && !item.settings.share && 
              <div className={styles.indicators}>
                <Tooltip content={'Internal use only'} placement='top'>
                  <i className="paperflite-lock"></i>
                </Tooltip>
              </div>
              }
              <NavigateEntity
                path={`/assets/${item?.id}`}
                className={styles.link}
                onClick={() => {
                  navigate(`/assets/${item?.id}`)
                }}
              >
                <img src={item?.icon?.full || DefaultAssetIcon} />
              </NavigateEntity>
            </div>
          <div>
              <p className={styles.title}>{item?.name}</p>
              <NavigateEntity
                path={`/assets/${item?.id}`}
                className={styles.link}
                onClick={()=> {
                  navigate(`/assets/${item?.id}`)
                }}
              >
                <Button
                  text="explore"
                  variant="tertiary"
                  icon="paperflite-right-arrow"
                />
              </NavigateEntity>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export function PlaceholderMetroContentCard() {
  return (
    <div className={cx(styles.metroPlaceholder)}>
      <div className={cx(styles.contentContainer)}>
        <div>
          <div className={cx(styles.name, styles.shine)}/>
          <div className={cx(styles.mainContent,styles.shine)}/>
        </div>
        <div className={styles.rightContent}>
          {_.times((3), (index) => (
            <div className={styles.content}>
              <div className={cx(styles.block, styles.shine)} />
              <div className={cx(styles.name, styles.shine)} />
            </div>
          ))}
      </div>
     </div>
    </div>
  );
}

export default MetroAssetCard;
